import React from 'react';
import './jds.css';
import { JdsButton } from './JdsButton';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  DoubleChevronLeftIcon,
  DoubleChevronRightIcon,
} from './icons';

// paginationComponent do react-data-table-component no visual JDS.
export function JdsPagination({
  rowsPerPage,
  rowCount,
  currentPage,
  onChangePage,
  onChangeRowsPerPage,
  paginationRowsPerPageOptions = [10, 15, 20, 25, 30],
}) {
  const numPages = Math.ceil(rowCount / rowsPerPage) || 1;
  const lastIndex = currentPage * rowsPerPage;
  const firstIndex = rowCount === 0 ? 0 : lastIndex - rowsPerPage + 1;
  const disabledPrevious = currentPage === 1;
  const disabledNext = currentPage === numPages;
  const range = `${firstIndex}-${
    currentPage === numPages ? rowCount : lastIndex
  } de ${rowCount}`;

  const pageButtons = [
    ['Primeira página', DoubleChevronLeftIcon, disabledPrevious, 1],
    ['Página anterior', ChevronLeftIcon, disabledPrevious, currentPage - 1],
    ['Próxima página', ChevronRightIcon, disabledNext, currentPage + 1],
    ['Última página', DoubleChevronRightIcon, disabledNext, numPages],
  ];

  return (
    <nav
      className="rdt_Pagination jds-pagination"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: 'var(--space-8) var(--space-16)',
        borderTop: 'var(--stroke-small) solid var(--border-neutral-subtle)',
        fontSize: 'var(--fs-13)',
        color: 'var(--fg-neutral-subtle)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span>Linhas por página</span>
        <select
          className="form-control"
          value={rowsPerPage}
          onChange={(e) =>
            onChangeRowsPerPage(Number(e.target.value), currentPage)
          }
          aria-label="Linhas por página"
          style={{ margin: '0 var(--space-12)', width: 'auto', height: 32 }}
        >
          {paginationRowsPerPageOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <span>{range}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {pageButtons.map(([label, Icon, disabled, page]) => (
          <JdsButton
            key={label}
            variant="ghost"
            color="neutral"
            size="sm"
            iconOnly
            disabled={disabled}
            onClick={() => onChangePage(page)}
            aria-label={label}
          >
            <Icon />
          </JdsButton>
        ))}
      </div>
    </nav>
  );
}
